export default __webpack_public_path__ + "static/media/pdfDark.2bb9bc7f.svg";